import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import {
  decimalValidate,
  dateConversion,
} from "../../../components/Validation";

const BudgetAllocationForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);

  const [employeelist, setEmployeelist] = useState(null);

  const [assignEmployeeId, setAssignEmployeeId] = useState();

  const [cropPlotId, setCropPlotId] = useState();
  const [cropPlotData, setCropPlotData] = useState([]);

  const [currencyCode, setCurrencyCode] = useState(
    localStorage.getItem("currencyCode")
  );

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  var d = new Date();

  const { sendRequest: getGatePass } = useHttp();
  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getCrppPlotDetails } = useHttp();

  const FillCrppPlotDetails = (id) => {
    getCrppPlotDetails(
      {
        url: `/api/CropDetailBudgetView/?fieldExecutiveId=${id}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("CropDetailBudgetView", data);
        setCropPlotData(data);
      }
    );
  };

  const { sendRequest: postProcurementReciept } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const now = new Date();
    const fieldActivityDetailIdGen = Math.round(now.getTime() / 1000);

    const MobCreatedDate = new Date().toISOString().slice(0, 10);

    if (props.update) {
      fieldActivityDetailIdGen = props.update.fieldActivityDetailId;
    }
    // productDetails.map((x) => (x["fieldActivityDetailId"] = fieldActivityDetailIdGen));

    cropPlotData.map(
      (x) =>
        (x["budgetApprovalDate"] = moment(frmRef.current.date.value).format(
          "DD/MM/YYYY",
          (x["mobCreatedDate"] = moment(MobCreatedDate).format(
            "DD/MM/YYYY hh:mm:ss"
          )),
          (x["createdBy"] = parseInt(localStorage.getItem("id"))),
          (x["entryLatLong"] = { lat: "18.6227329", long: "73.7748456" }),
          (x["orgId"] = localStorage.getItem("orgId"))
        ))
    );

    const data = {
      budgetApproval: cropPlotData,
    };
    //console.log("data", data);

    postProcurementReciept(
      {
        url: "/api/budgetApproval/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Budget approval detail ${props.update ? "updated" : "added"} `
        );
        props.addForm(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Field Activity Budget</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date</label>

                        <input
                          type={"date"}
                          id={"date"}
                          required
                          ref={(el) => (frmRef.current["date"] = el)}
                          className="form-control"
                          max={currentDate}
                          value={selectedDate}
                          onChange={handleDateChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Start Time </label>

                        <input
                          type={"time"}
                          id={"activityStartTime"}
                          required
                          ref={(el) =>
                            (frmRef.current["activityStartTime"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Assigned Supervisor </label>

                        <select
                          id="emp_id"
                          required
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["assignEmployeeId"] = el)
                          }
                          value={assignEmployeeId}
                          onChange={(e) => {
                            var id = 0;

                            if (e.target.value != "--Select Employee--") {
                              id = e.target.value;
                            }
                            setAssignEmployeeId(id);
                            FillCrppPlotDetails(id);
                          }}
                        >
                          <option selected value="">
                            --Select Employee--
                          </option>
                          {employeelist &&
                            employeelist.map((x) => (
                              <option
                                key={x.userId}
                                user-id={x.userId}
                                value={x.userId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th>Sr. No</th>
                          <th>Plot Name</th>
                          <th>Crop Name </th>
                          <th>Variety Name</th>
                          <th>Area </th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th>Budget Amount Approved</th>
                        </tr>
                      </thead>

                      <tbody>
                        {cropPlotData &&
                          cropPlotData.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>
                                <td>
                                  {itm.area} {itm.unitAbbreviation}{" "}
                                </td>

                                <td>
                                  <input
                                    type={"date"}
                                    id={"date"}
                                    required
                                    defaultValue={itm.fromDate}
                                    ref={(el) =>
                                      (productRef.current["fromDate"] = el)
                                    }
                                    className="inputs"
                                    min={selectedDate}
                                    onChange={(e) => {
                                      var fdate = dateConversion(
                                        e.target.value,
                                        "YYYY-MM-DD",
                                        "DD/MM/YYYY"
                                      );

                                      cropPlotData[i].fromDate = fdate;
                                      //console.log(
                                       // "cropPlotData[i].fromDate",
                                      //  cropPlotData[i]
                                    //  );
                                      setCropPlotData([...cropPlotData]);
                                      //console.log(
                                     //   "setCropPlotData",
                                       // setCropPlotData
                                     // );
                                    }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type={"date"}
                                    id={"date"}
                                    required
                                    defaultValue={itm.toDate}
                                    ref={(el) =>
                                      (productRef.current["toDate"] = el)
                                    }
                                    className="inputs"
                                    min={selectedDate}
                                    onChange={(e) => {
                                      var tdate = dateConversion(
                                        e.target.value,
                                        "YYYY-MM-DD",
                                        "DD/MM/YYYY"
                                      );

                                      cropPlotData[i].toDate = tdate;

                                      setCropPlotData([...cropPlotData]);
                                      //console.log(
                                      //   "setCropPlotData",
                                      //   setCropPlotData
                                      // );
                                    }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type={"number"}
                                    id={"rate"}
                                    required
                                    ref={(el) =>
                                      (productRef.current["rate"] = el)
                                    }
                                    className="input-product"
                                    onChange={(e) => {
                                      decimalValidate(e);

                                      cropPlotData[i].approvedBudget =
                                        e.target.value;
                                      //console.log(
                                      //   "cropPlotData[i].approvedBudget",
                                      //   cropPlotData[i]
                                      // );
                                      setCropPlotData([...cropPlotData]);
                                      //console.log(
                                      //   "setCropPlotData",
                                      //   setCropPlotData
                                      // );
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default BudgetAllocationForm;
